// assets
import { IconReport  } from '@tabler/icons';

// constant
const icons = {
    IconReport 
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const reports = {
    id: 'reports',
    type: 'group',
    children: [
        {
            id: 'reports',
            title: 'Reports',
            type: 'collapse',
            icon: icons.IconReport ,
            children: [
                // {
                //     id: 'win/lose',
                //     title: 'Win/Lose',
                //     type: 'item',
                //     url: '/icons/tabler-icons',
                //     breadcrumbs: false
                // },
                // {
                //     id: 'memberOutstanding',
                //     title: 'Member Outstanding',
                //     type: 'item',
                //     url: '/icons/material-icons',
                //     breadcrumbs: false
                // },
                {
                    id: 'transactions',
                    title: 'Transactions',
                    type: 'item',
                    url: '/reports/statement',
                    breadcrumbs: true
                },
                // {
                //     id: 'paymentAndTransferHistory',
                //     title: 'Payment & Transfer History',
                //     type: 'item',
                //     url: '/icons/material-icons',
                //     breadcrumbs: false
                // },
                {
                    id: 'matchResult',
                    title: 'Match Result',
                    type: 'item',
                    url: '/reports/matchResult',
                    breadcrumbs: true
                }
            ]
        }
    ]
};

export default reports;
